import React from "react";
import PieEcharts from "./PieEcarts";
import Util from "../util";
import { withRouter } from "react-router";
import './position.css'
import { connect } from "react-redux";

class Position extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  toSelectionPool = () => {
    window.open('https://app.amcfortune.com/wAppStatic/AlternativeFund.pdf')
    // window.location.href='https://app.amcfortune.com/wAppStatic/AlternativeFund.pdf'
  }; 
  
  render() {
    const {  legendData = [], seriesData = [], updateTimeStr } = this.props;
    return (
      
        <div className="Position_container" >
          <div className="Position_header">
            <span className="Position_title">策略持仓</span>
            <span>更新时间：{updateTimeStr}</span>
            <div className="SelectPool_btn"  onClick={this.toSelectionPool}>
              <span>产品备选池</span>
              <img style={{ width: ".2rem" }} src={require("../img/n_icon_arrow_gray@2x.png")} />
            </div>
          </div>
          <PieEcharts height="140px" legendData={legendData} seriesData={seriesData} />
        </div>
    
    
    );
  }
}
function mapStateToProps(state, ownProps) {
  const {superFundBasicInfo={}}=state.strategiesDetails
  return {
    seriesData:superFundBasicInfo.seriesData,
    legendData:superFundBasicInfo.legendData,
    updateTimeStr:superFundBasicInfo.updateTimeStr
  };
}
export default withRouter(connect(mapStateToProps)(Position));



// WEBPACK FOOTER //
// ./src/components/StopPosition.js